import React, {
  Fragment,
  useContext,
  useEffect,
  useState,
  useRef,
  useMemo,
  useCallback,
} from "react";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import { Link, Redirect } from "react-router-dom";
import { ServiciosContext } from "../../../context/ServiciosContext";
import { ConfiguracionContext } from "../../../context/ConfiguracionContext";
import { Button } from "primereact/button";
import { styled } from "@mui/material/styles";
import { Navigate, useNavigate } from "react-router-dom";

const FILAS_RESUMEN = [
  { nombre: "Rojo", key: "rojo", color: "#e5484d" },
  { nombre: "Amarillo", key: "amarillo", color: "#f2c94c" },
  { nombre: "Verde", key: "verde", color: "#30a46c" },
  { nombre: "Fuccia", key: "fuccia", color: "#d6409f" },
  { nombre: "Azul", key: "azul", color: "#3b82f6" },
  { nombre: "Naranja", key: "naranja", color: "#f59e0b" },
  { nombre: "Blanco", key: "blanco", color: "#e2e8f0" },
  { nombre: "Negro", key: "negro", color: "#334155" },
  { nombre: "Celeste", key: "celeste", color: "#4dd0e1" },
];

export default function ResumenServicio(props) {
  //const classes = useStyles();
  const [value, setValue] = useState(null);
  const [value2, setValue2] = useState(null);
  const [inputValue, setInputValue] = useState("");
  const [options, setOptions] = useState([]);
  const loaded = useRef(false);
  const [center, setCenter] = useState(null);
  const [markers, setMarkers] = useState(null);
  const [selected, setSelected] = useState(null);
  const [map, setMap] = useState(null);
  const [afiliadoCartera, guardarAfiliadoCartera] = useState(null);
  const [iniciarCursor, setIniciarCursor] = useState(0);

  const serviciosContext = useContext(ServiciosContext);
  const { resumen, demorados } = serviciosContext;

  const configuracionContext = useContext(ConfiguracionContext);
  const { configuracion } = configuracionContext;

  //const classes = useStyles({color: afiliado ? afiliado.motivoConsultaColor : null });

  //const theme = useTheme();

  //console.log(demorados)
  //console.log(resumen)

  const filas =
    configuracion && configuracion.destinatario === 2
      ? [...FILAS_RESUMEN, { nombre: "Marrón", key: "marron", color: "#a16207" }]
      : configuracion && configuracion.destinatario === 4
        ? // Destinatario 4: fila de contenciones (GRIS)
          [...FILAS_RESUMEN, { nombre: "Gris", key: "gris", color: "#8b95a1" }]
        : FILAS_RESUMEN;

  const StatCol = ({ valor, etiqueta, alerta }) => (
    <Box sx={{ minWidth: 38, textAlign: "center" }}>
      <Typography
        sx={{
          fontSize: "0.95rem",
          fontWeight: 700,
          lineHeight: 1.1,
          color: alerta && Number(valor) > 0 ? "error.main" : "text.primary",
        }}
      >
        {valor}
      </Typography>
      <Typography
        sx={{
          fontSize: "0.58rem",
          textTransform: "uppercase",
          letterSpacing: "0.04em",
          color: "text.secondary",
        }}
      >
        {etiqueta}
      </Typography>
    </Box>
  );

  return (
    <Fragment>
      {resumen && demorados ? (
        <Box sx={{ p: 1.5, width: "100%" }}>
          <Stack
            direction="row"
            justifyContent="flex-end"
            spacing={1.5}
            sx={{ pr: 1.25, pb: 0.5 }}
          >
            <Typography sx={{ fontSize: "0.58rem", minWidth: 38, textAlign: "center", textTransform: "uppercase", letterSpacing: "0.04em", color: "text.secondary" }}>
              Total
            </Typography>
            <Typography sx={{ fontSize: "0.58rem", minWidth: 38, textAlign: "center", textTransform: "uppercase", letterSpacing: "0.04em", color: "text.secondary" }}>
              Pend
            </Typography>
            <Typography sx={{ fontSize: "0.58rem", minWidth: 38, textAlign: "center", textTransform: "uppercase", letterSpacing: "0.04em", color: "text.secondary" }}>
              Demor
            </Typography>
          </Stack>

          <Stack spacing={0.75}>
            {filas.map((fila) => {
              const tot = resumen[`${fila.key}Totales`] ?? 0;
              const pend = resumen[`${fila.key}Pendientes`] ?? 0;
              const dem = demorados[`${fila.key}Demorados`] ?? 0;
              return (
                <Box
                  key={fila.key}
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.25,
                    px: 1.25,
                    py: 0.75,
                    borderRadius: 2,
                    border: "1px solid",
                    borderColor: "divider",
                    bgcolor: dem > 0 ? "rgba(229,72,77,0.06)" : "background.paper",
                  }}
                >
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "3px",
                      flexShrink: 0,
                      bgcolor: fila.color,
                      border:
                        fila.key === "blanco" ? "1px solid #cbd5e1" : "none",
                    }}
                  />
                  <Typography
                    sx={{
                      flex: 1,
                      fontSize: "0.78rem",
                      fontWeight: 600,
                      textTransform: "uppercase",
                      letterSpacing: "0.03em",
                      color: "text.secondary",
                    }}
                  >
                    {fila.nombre}
                  </Typography>
                  <StatCol valor={tot} etiqueta="tot" />
                  <StatCol valor={pend} etiqueta="pend" />
                  <StatCol valor={dem} etiqueta="dem" alerta />
                </Box>
              );
            })}
          </Stack>
        </Box>
      ) : null}
    </Fragment>
  );
}
